import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { MapPin, Route } from "lucide-react";

export const WhereWeDrive = () => {
  const [routes, setRoutes] = useState([]);
  useEffect(() => {
    api.get("/destinations")
      .then((r) => setRoutes((r.data || []).filter((d) => d.type === "route")))
      .catch(() => {});
  }, []);
  if (!routes.length) return null;
  return (
    <div data-testid="where-we-drive" className="rounded-3xl bg-charcoal-800 p-8 lg:p-12 text-sand-100">
      <p className="text-xs uppercase tracking-[0.2em] text-sage font-medium mb-3 inline-flex items-center gap-2">
        <Route size={14} /> Where we drive
      </p>
      <h2 className="text-2xl sm:text-3xl font-normal text-white">
        Supported pickup &amp; drop-off points
      </h2>
      <p className="mt-3 max-w-2xl text-sand-100/80 leading-relaxed">
        Mérida is our home base — and our drivers cover these cities and border crossings as start or end
        points for your move. Don't see yours? Ask us; custom routes are our specialty.
      </p>
      <div className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {routes.map((r) => (
          <Link key={r.id} to={`/cost-calculator?route=${encodeURIComponent(r.name)}`}
            data-testid={`route-point-${r.id}`}
            className="group rounded-2xl bg-white/5 border border-white/10 px-4 py-3 transition-colors hover:bg-white/10 hover:border-sage/50">
            <p className="font-medium text-white inline-flex items-center gap-1.5">
              <MapPin size={13} className="text-terracotta" /> {r.name}
            </p>
            <p className="mt-0.5 text-xs text-sand-100/60">{r.region}</p>
            <p className="mt-1.5 text-xs font-medium text-sage opacity-0 transition-opacity group-hover:opacity-100">
              Get an instant estimate →
            </p>
          </Link>
        ))}
      </div>
      <Link to="/drivers" data-testid="where-we-drive-drivers-link"
        className="mt-6 inline-block text-sm font-medium text-sage underline underline-offset-4 hover:text-white transition-colors">
        Meet the drivers behind the wheel →
      </Link>
      <div className="mt-4 flex flex-wrap gap-x-4 gap-y-1.5 text-xs text-sand-100/60">
        {routes.filter((r) => r.slug).map((r) => (
          <Link key={r.slug} to={`/routes/${r.slug}`} data-testid={`route-guide-link-${r.slug}`}
            className="underline underline-offset-2 hover:text-white transition-colors">
            {r.name} → Mérida guide
          </Link>
        ))}
      </div>
    </div>
  );
};
